var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle2, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCircleCelular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 56,
    r: 56,
    fill: "#E8F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.0557 95.9167L60.7803 92.4675C60.9899 92.0483 61.4616 91.8425 61.928 91.8888C64.0493 92.0992 67.8649 91.1457 72.2502 82.375",
    stroke: "#444444",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4979 83.1895C67.4405 90.6087 63.9439 91.458 61.9424 91.2652C61.4694 91.2196 60.9915 91.4328 60.7863 91.8614L57.5586 98.605C57.374 98.9908 56.9645 99.2164 56.5398 99.1665L47.9936 98.161C47.3184 98.0816 46.9176 97.3661 47.2025 96.7488L53.8568 82.3309C54.0203 81.9768 54.3747 81.75 54.7648 81.75H70.632C71.3754 81.75 71.8545 82.5373 71.4979 83.1895Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7222 37.5833L77.4692 35.5451C78.7744 34.0223 81.0997 33.933 82.5179 35.3512V35.3512C83.7807 36.614 83.8683 38.6328 82.7196 40.0003L75.9999 48",
    stroke: "#444444",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4855 45.041L82.7543 39.9591C83.8834 38.6149 83.7973 36.6306 82.556 35.3893C81.132 33.9653 78.7872 34.0923 77.5254 35.6616L73.3666 40.8339C72.3593 42.0867 72.3967 43.8819 73.4552 45.0917C74.7929 46.6205 77.1789 46.5965 78.4855 45.041Z",
    fill: "white",
    stroke: "#444444",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7224 29.25H49.8613C47.6522 29.25 45.8613 31.0409 45.8613 33.25V78.0278C45.8613 80.2369 47.6522 82.0278 49.8613 82.0278H55.3752H71.7224C73.9316 82.0278 75.7224 80.2369 75.7224 78.0278V33.25C75.7224 31.0409 73.9316 29.25 71.7224 29.25Z",
    fill: "#0099CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0558 77.1667H63.2224M55.3752 82.0278H71.7224C73.9316 82.0278 75.7224 80.2369 75.7224 78.0278V33.25C75.7224 31.0409 73.9316 29.25 71.7224 29.25H49.8613C47.6522 29.25 45.8613 31.0409 45.8613 33.25V78.0278C45.8613 80.2369 47.6522 82.0278 49.8613 82.0278H55.3752Z",
    stroke: "#0099CC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36.25C51 35.1454 51.8954 34.25 53 34.25H69C70.1046 34.25 71 35.1454 71 36.25V64.75C71 65.8546 70.1046 66.75 69 66.75H53C51.8954 66.75 51 65.8546 51 64.75V36.25Z",
    fill: "#E8F9FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.4167,
    cy: 52.1667,
    r: 3.66667,
    fill: "white",
    stroke: "#444444"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0228 56.5995L73.7208 58.0643C72.5314 59.4023 72.6707 61.4558 74.03 62.6209C75.3551 63.7566 77.3458 63.6215 78.5052 62.3171L79.8072 60.8524C80.9966 59.5143 80.8573 57.4609 79.498 56.2958C78.1729 55.16 76.1822 55.2951 75.0228 56.5995Z",
    fill: "white",
    stroke: "#444444"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7171 64.2384L74.4151 65.7032C73.2257 67.0412 73.3651 69.0947 74.7243 70.2598C76.0494 71.3956 78.0401 71.2605 79.1996 69.9561L80.5016 68.4913C81.691 67.1533 81.5516 65.0998 80.1923 63.9347C78.8672 62.7989 76.8766 62.934 75.7171 64.2384Z",
    fill: "white",
    stroke: "#444444"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.75 80.5C54.75 72.5447 49.3917 67.8803 46.2876 65.661C46.0206 65.4702 45.8611 65.1653 45.8611 64.8372V49C45.8611 48.4477 45.4134 48 44.8611 48H43.6111C41.402 48 39.6111 49.7909 39.6111 52V59.0121C39.6111 59.0779 39.6046 59.1436 39.5917 59.2082L37.0267 72.033C36.8997 72.6681 36.9288 73.3247 37.1116 73.9461L40.1945 84.4281C40.2659 84.6707 40.2427 84.9313 40.1296 85.1575L34.75 95.9167",
    stroke: "#444444",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4167 48H44.4964C42.3112 48 40.5304 49.7537 40.4968 51.9386L40.3763 59.7884C40.3754 59.846 40.3696 59.9035 40.3588 59.9601L38.0478 72.093C37.9341 72.6898 37.9578 73.3047 38.1172 73.8909L41.1038 84.8755C41.1709 85.1224 41.1409 85.3855 41.0199 85.6109L35.9997 94.9614C35.6862 95.5454 36.0173 96.2673 36.6644 96.4107L48.5588 99.0466C49.0746 99.1609 49.5903 98.8543 49.7362 98.3465L54.7111 81.0366C54.7369 80.9468 54.7502 80.8523 54.7495 80.7588C54.6907 72.7894 49.7062 68.1094 46.8136 65.8769C46.564 65.6842 46.4167 65.3898 46.4167 65.0745V49C46.4167 48.4477 45.969 48 45.4167 48Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8936 11C51.8936 14.1848 48.1848 17.8936 45 17.8936C48.1848 17.8936 51.8936 21.6024 51.8936 24.7872C51.8936 21.6024 55.6024 17.8936 58.7872 17.8936C55.6024 17.8936 51.8936 14.1848 51.8936 11Z",
    fill: "#0099CC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8936 46C14.8936 49.1848 11.1848 52.8936 8 52.8936C11.1848 52.8936 14.8936 56.6024 14.8936 59.7872C14.8936 56.6024 18.6024 52.8936 21.7872 52.8936C18.6024 52.8936 14.8936 49.1848 14.8936 46Z",
    fill: "#0099CC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8936 29C90.8936 32.1848 87.1848 35.8936 84 35.8936C87.1848 35.8936 90.8936 39.6024 90.8936 42.7872C90.8936 39.6024 94.6024 35.8936 97.7872 35.8936C94.6024 35.8936 90.8936 32.1848 90.8936 29Z",
    fill: "#0099CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCircleCelular);
export default __webpack_public_path__ + "static/media/ico_circle_celular.f2dc7ff3ab6fada918c683f7071562d9.svg";
export { ForwardRef as ReactComponent };